export default "__VITE_ASSET__YVqTEZMW__"